module.exports = __webpack_public_path__ + "fonts/NeutraTextDemiAlt.aa22209b.otf";